function Button({ children, textOnly, className, ...props }) {
  let cssClasses = textOnly ? 'text-button' : 'button';
  if (className) {
    cssClasses = ' ' + className;
  }
  return (
    <button className={cssClasses} {...props}>
      {children}
    </button>
  );
}

export default Button;
